module.exports = __webpack_public_path__ + "img/azuread.89d0693d.svg";